import ImageTransform from '@tti/image-transform';
import React, { FunctionComponent } from 'react';
import { ProductRowStyles as S } from './ProductRow.styles';

export type ProductRowProps = IncludedProduct;

const ProductRow: FunctionComponent<ProductRowProps> = (props) => {
  const Inner = (
    <>
      <S.Media>
        <img
          loading="lazy"
          src={new ImageTransform(props.image).width(64).url}
          alt={props.modelCode}
          role={props.modelCode ? undefined : 'presentation'}
        />
      </S.Media>

      <S.Content>
        <S.Name dangerouslySetInnerHTML={{ __html: props.title }}></S.Name>
        {props.modelCode && <S.Code>{props.modelCode}</S.Code>}
      </S.Content>

      <S.Quantity>{props.quantity}</S.Quantity>
    </>
  );

  if (props.url) {
    return (
      <S.LinkContainer href={props.url} target="_blank">
        {Inner}
      </S.LinkContainer>
    );
  }

  return <S.Container>{Inner}</S.Container>;
};

export default ProductRow;
